module.exports = __webpack_public_path__ + "static/media/table_ace2ace.ab3fcd00.png";